import React__default from 'react';
import { ButtonWrapper } from './styles.js';

const Button = ({ children, className, disabled = false, fullWidth = false, href, iconOnly = false, onClick = () => null, shadow = false, size = 'L', target, variant, }) => (React__default.createElement(ButtonWrapper, { className: className, "data-testid": `button-${variant}`, "$fullWidth": fullWidth, "$iconOnly": iconOnly, onClick: onClick, "$shadow": shadow, "$size": size, "$variant": variant, ...(disabled && { disabled }), ...(!disabled &&
        href && {
        as: 'a',
        href,
        target,
        ...(target === '_blank' && { rel: 'noopener noreferrer' }),
    }) }, children));

export { Button };
